import axios from "axios";
import React from "react";
import moment from "moment";
import { toast } from "react-toastify";
import truckRotate0 from "../assets/img/truckrotate-0.svg";
import truckRotate40 from "../assets/img/truckrotate-40.svg";
import truckRotate90 from "../assets/img/truckrotate-90.svg";
import truckRotate140 from "../assets/img/truckrotate-140.svg";
import truckRotate180 from "../assets/img/truckrotate-180.svg";
import truckRotate220 from "../assets/img/truckrotate-220.svg";
import truckRotate270 from "../assets/img/truckrotate-270.svg";
import truckRotate320 from "../assets/img/truckrotate-320.svg";
import threePlTruckRotate0 from "../assets/img/3pl-truckrotate-0.svg";
import threePlTruckRotate40 from "../assets/img/3pl-truckrotate-40.svg";
import threePlTruckRotate90 from "../assets/img/3pl-truckrotate-90.svg";
import threePlTruckRotate140 from "../assets/img/3pl-truckrotate-140.svg";
import threePlTruckRotate180 from "../assets/img/3pl-truckrotate-180.svg";
import threePlTruckRotate220 from "../assets/img/3pl-truckrotate-220.svg";
import threePlTruckRotate270 from "../assets/img/3pl-truckrotate-270.svg";
import threePlTruckRotate320 from "../assets/img/3pl-truckrotate-320.svg";
import renteeTruckRotate0 from "../assets/img/rentee-truckrotate-0.svg";
import renteeTruckRotate40 from "../assets/img/rentee-truckrotate-40.svg";
import renteeTruckRotate90 from "../assets/img/rentee-truckrotate-90.svg";
import renteeTruckRotate140 from "../assets/img/rentee-truckrotate-140.svg";
import renteeTruckRotate180 from "../assets/img/rentee-truckrotate-180.svg";
import renteeTruckRotate220 from "../assets/img/rentee-truckrotate-220.svg";
import renteeTruckRotate270 from "../assets/img/rentee-truckrotate-270.svg";
import renteeTruckRotate320 from "../assets/img/rentee-truckrotate-320.svg";
import suvWhite0 from "../assets/img/suv-white-0.png";
import suvWhite40 from "../assets/img/suv-white-40.png";
import suvWhite90 from "../assets/img/suv-white-90.png";
import suvWhite140 from "../assets/img/suv-white-140.png";
import suvWhite180 from "../assets/img/suv-white-180.png";
import suvWhite220 from "../assets/img/suv-white-220.png";
import suvWhite270 from "../assets/img/suv-white-270.png";
import suvWhite320 from "../assets/img/suv-white-320.png";
import suvYellow0 from "../assets/img/suv-yellow-0.png";
import suvYellow40 from "../assets/img/suv-yellow-40.png";
import suvYellow90 from "../assets/img/suv-yellow-90.png";
import suvYellow140 from "../assets/img/suv-yellow-140.png";
import suvYellow180 from "../assets/img/suv-yellow-180.png";
import suvYellow220 from "../assets/img/suv-yellow-220.png";
import suvYellow270 from "../assets/img/suv-yellow-270.png";
import suvYellow320 from "../assets/img/suv-yellow-320.png";
import suvOrange0 from "../assets/img/suv-orange-0.png";
import suvOrange40 from "../assets/img/suv-orange-40.png";
import suvOrange90 from "../assets/img/suv-orange-90.png";
import suvOrange140 from "../assets/img/suv-orange-140.png";
import suvOrange180 from "../assets/img/suv-orange-180.png";
import suvOrange220 from "../assets/img/suv-orange-220.png";
import suvOrange270 from "../assets/img/suv-orange-270.png";
import suvOrange320 from "../assets/img/suv-orange-320.png";
import circleMarkerRed from "../assets/img/circle-marker-red.svg";
import circleMarkerGreen from "../assets/img/circle-marker-green.svg";
import circleMarkerBlue from "../assets/img/circle-marker-blue.svg";
import circleMarkerBlack from "../assets/img/circle-marker-black.svg";
import CustomToast from "../components/CustomToast/CustomToast";
import { BiSolidError } from "react-icons/bi";

export const imageFormatter = (data, setModalContent, toggleModal) => {
  let assetPicture = data;

  if (assetPicture && assetPicture.type === "Buffer") {
    assetPicture = String.fromCharCode.apply(null, assetPicture.data);
  }

  let width = "100%";
  let height = "40%";
  if (!assetPicture) {
    assetPicture = "/assets/img/empty-file.png";
    width = "25px";
    height = "30px";
  }

  const isPdf = assetPicture.endsWith(".pdf");
  const handleClick = () => {
    setModalContent({ isPdf, src: assetPicture });
    toggleModal();
  };

  return (
    <>
      {isPdf ? (
        <>
          <embed
            width={width}
            height={height}
            src={assetPicture}
            type="application/pdf"
          />
          <i
            onClick={width === "25px" ? null : handleClick}
            className="text-primary"
            style={
              width === "25px" ? { cursor: "auto" } : { cursor: "pointer" }
            }
          >
            <b>Open document</b>
          </i>
        </>
      ) : (
        <img
          width={width}
          height={height}
          src={assetPicture}
          loading="lazy"
          onClick={width === "25px" ? null : handleClick}
          style={width === "25px" ? { cursor: "auto" } : { cursor: "pointer" }}
          alt="Preview"
        />
      )}
    </>
  );
};

export const fileNameFormat = (name) => {
  var baseName = `${name} - `;
  var baseDate = new Date();
  var date = moment(baseDate).format("DD-MMM-YYYY HH:mm");
  var strDate = date.toString();
  return baseName + strDate + ".csv";
};

export const fileNameFormatWithType = (name, fileType) => {
  var baseDate = new Date();
  var date = moment(baseDate).format("DD-MMM-YYYY HH:mm");
  var strDate = date.toString();
  return `${name} - ${strDate}.${fileType}`;
};

export const bootstrapTableOption = (params) => {
  return {
    defaultSortName: "id", // default sort column name
    defaultSortOrder: "asc", // default sort order
    noDataText:
      params && !!params.noDataText ? params.noDataText : "No Data Found!",
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
    ],
    sizePerPage: 20,
    exportCSVSeparator: ";",
    ...(params && params.defaultSortName
      ? { defaultSortName: params.defaultSortName }
      : {}),
    ...(params && params.defaultSortOrder
      ? { defaultSortOrder: params.defaultSortOrder }
      : {}),
    ...(params && params.btnGroup ? { btnGroup: params.btnGroup } : {}),
  };
};

const onArrayForm = (name, data, obj) => {
  let newObj = [...obj];
  for (const key in data) {
    if (
      (Array.isArray(data[key]) || typeof data[key] === "object") &&
      !(data[key] instanceof File)
    ) {
      newObj = onArrayForm(`${name}[${key}]`, data[key], newObj);
    } else {
      newObj = [...newObj, { label: `${name}[${key}]`, value: data[key] }];
    }
  }
  return newObj;
};

export const expandJSON = (data) => {
  let obj = [];
  for (const key in data) {
    if (
      Array.isArray(data[key]) ||
      (typeof data[key] === "object" && !(data[key] instanceof File))
    ) {
      obj = onArrayForm(`${key}`, data[key], obj);
    } else {
      obj = [
        ...obj,
        {
          label: key,
          value: data[key],
        },
      ];
    }
  }
  return obj;
};

export const onFetch = (
  auth,
  { url, data, type = "json", cancelToken=null },
  { beforeSend, success, error }
) => {
  beforeSend();

  let form = null;
  if (type === "formdata") {
    form = new FormData();
    const dt = expandJSON(data);
    for (let i in dt) {
      form.append(dt[i].label, dt[i].value);
    }
  }

  axios({
    method: "post",
    url: url,
    headers: {
      Authorization: auth,
      ...(type === "json" ? { "Content-Type": "application/json" } : {}),
    },
    data: type === "json" ? data : form,
    ...(!!cancelToken ? { cancelToken } : {}),
  })
    .then((response) => {
      success(response);
    })
    .catch(function (err) {
      error(err);
    });
};

const onFetchSingle = (auth, { url, data, type }, cb) =>
  onFetch(
    auth,
    { url, data, type },
    {
      beforeSend: () => null,
      success: (response) => cb(null, response),
      error: (err) => cb(err, false),
    }
  );

export const onFetchAll = (auth,
  { url, data: datas, type },
  { beforeSend = () => null, success, error },
  index = 0,
  results = [],
  errors = []
) => {
  let dts = [];
  let dte = [];
  if (index === 0) {
    beforeSend();
  }
  if (!!datas[index]) {
    onFetchSingle(auth,{ url, data: datas[index], type }, (err, response) => {
      dts = [...results];
      dte = [...errors];
      if (!err) {
        dts = [...dts, response];
      } else {
        dte = [...dte, err];
      }

      if (index < datas.length - 1) {
        onFetchAll(
          auth,
          { url, data: datas, type },
          { beforeSend, success, error },
          index + 1,
          [...dts],
          [...dte]
        );
      } else {
        success(dts.length > 0 ? dts : false);
        if (dte.length > 0) {
          error(dte);
        }
      }
    });
  } else {
    success(dts.length > 0 ? dts : false);
    if (dte.length > 0) {
      error(dte);
    }
  }
};

export const onFetchAllAsync =
  (token) =>
  (
    { url, data: datas = [], type },
    { beforeSend = () => null, success, error }
  ) => {
    beforeSend();
    Promise.all(
      (Array.isArray(datas) ? datas : []).map((item) => {
        var auth = token;

        const form = new FormData();
        const dt = expandJSON(item);
        for (let i in dt) {
          form.append(dt[i].label, dt[i].value);
        }
        return axios({
          method: "post",
          url: url,
          headers: {
            Authorization: auth,
            ...(type === "json" ? { "Content-Type": "application/json" } : {}),
          },
          data: type === "json" ? item : form,
        });
      })
    )
      .then((response) => {
        success(response);
      })
      .catch((err) => {
        error(err);
      });
  };

// interface IConfig{
//   url: string;
//   path?: string;
//   method?: "GET"|"POST"|"PUT"|"DELETE",
//   data?: unknown;
//   type?: "formdata" | "json"
// }

export const onFetchArrayAsync =
  (token) =>
  (config = [], { beforeSend = () => null, success, error }) => {
    beforeSend();
    var auth = token;
    Promise.all(
      config.map((item) => {
        const form = new FormData();
        if (item.data) {
          const dt = expandJSON(item.data);
          for (let i in dt) {
            form.append(dt[i].label, dt[i].value);
          }
        }
        return axios({
          method: !!item.method ? item.method : "GET",
          url: item.url + (!!item.path ? item.path : ""),
          headers: {
            Authorization: auth,
            ...(item.type === "json"
              ? { "Content-Type": "application/json" }
              : {}),
          },
          ...((!!item.method ? item.method : "GET") === "GET"
            ? {
                params: item.data,
              }
            : {
                data: item.type === "json" ? item.data : form,
              }),
        });
      })
    )
      .then((response) => {
        success(response);
      })
      .catch((err) => {
        error(err);
      });
  };

export const showTruckValueBasedOnEngineAndSpeedStatus = (spd, wrn) => {
  if (spd > 0 && wrn === 0) return "OFF (WARNING!)";
  if (wrn === 0) return "OFF";
  if (spd > 0) return "ON MOVING";
  if (spd === 0) return "STANDBY";
  return "INACTIVE";
};

export const handleRequestError = (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        return toast.error(
          <CustomToast
            text="Invalid username or password! Please try again!"
            icon={<BiSolidError />}
          />,
          {
            autoClose: 3000,
          }
        );
      case 404:
        return toast.error(
          <CustomToast text="Data not found!" icon={<BiSolidError />} />,
          {
            autoClose: 3000,
          }
        );
      case 500:
        return toast.error(
          <CustomToast
            text="Server cannot be contacted! Please ask your system administrator!"
            icon={<BiSolidError />}
          />,
          {
            autoClose: 3000,
          }
        );
      case 400:
        return toast.error(
          <CustomToast
            text={error.response.data.message}
            icon={<BiSolidError />}
          />,
          {
            autoClose: 3000,
          }
        );
      default:
        return toast.error(
          <CustomToast
            text="Something went wrong... Please try again later..."
            icon={<BiSolidError />}
          />,
          {
            autoClose: 3000,
          }
        );
    }
  } else if (error.request) {
    return toast.error(
      <CustomToast
        text="Request error! Please try again later..."
        icon={<BiSolidError />}
      />,
      {
        autoClose: 3000,
      }
    );
  } else {
    return toast.error(
      <CustomToast
        text="Something went wrong... Please try again later..."
        icon={<BiSolidError />}
      />,
      {
        autoClose: 3000,
      }
    );
  }
};

export const handleFleetIcon = (radian, owner) => {
  const getIcon = (prefix) => {
    if (radian >= 0 && radian < Math.PI / 4) {
      return prefix[0];
    } else if (radian >= Math.PI / 4 && radian < Math.PI / 2) {
      return prefix[40];
    } else if (radian >= Math.PI / 2 && radian < (3 * Math.PI) / 4) {
      return prefix[90];
    } else if (radian >= (3 * Math.PI) / 4 && radian < Math.PI) {
      return prefix[140];
    } else if (radian >= Math.PI && radian < (5 * Math.PI) / 4) {
      return prefix[180];
    } else if (radian >= (5 * Math.PI) / 4 && radian < (3 * Math.PI) / 2) {
      return prefix[220];
    } else if (radian >= (3 * Math.PI) / 2 && radian < (7 * Math.PI) / 4) {
      return prefix[270];
    } else if (radian >= (7 * Math.PI) / 4 && radian < 2 * Math.PI) {
      return prefix[320];
    } else {
      return prefix[0]; // default value
    }
  };

  const iconSets = {
    ...(process.env.IS_MITRATEL
      ? {
        "Own Fleet": {
            0: suvWhite0,
            40: suvWhite40,
            90: suvWhite90,
            140: suvWhite140,
            180: suvWhite180,
            220: suvWhite220,
            270: suvWhite270,
            320: suvWhite320,
          },
        "Own fleet": {
            0: suvWhite0,
            40: suvWhite40,
            90: suvWhite90,
            140: suvWhite140,
            180: suvWhite180,
            220: suvWhite220,
            270: suvWhite270,
            320: suvWhite320,
          },
        "3PL Fleet": {
            0: suvOrange0,
            40: suvOrange40,
            90: suvOrange90,
            140: suvOrange140,
            180: suvOrange180,
            220: suvOrange220,
            270: suvOrange270,
            320: suvOrange320,
          },
        "3PL fleet": {
            0: suvOrange0,
            40: suvOrange40,
            90: suvOrange90,
            140: suvOrange140,
            180: suvOrange180,
            220: suvOrange220,
            270: suvOrange270,
            320: suvOrange320,
          },
        "Rental Fleet": {
            0: suvYellow0,
            40: suvYellow40,
            90: suvYellow90,
            140: suvYellow140,
            180: suvYellow180,
            220: suvYellow220,
            270: suvYellow270,
            320: suvYellow320,
          },
        "Rental fleet": {
            0: suvYellow0,
            40: suvYellow40,
            90: suvYellow90,
            140: suvYellow140,
            180: suvYellow180,
            220: suvYellow220,
            270: suvYellow270,
            320: suvYellow320,
          },
      }
      : {
          "Own Fleet": {
            // icon truck hijau
            0: truckRotate0,
            40: truckRotate40,
            90: truckRotate90,
            140: truckRotate140,
            180: truckRotate180,
            220: truckRotate220,
            270: truckRotate270,
            320: truckRotate320,
          },
          "Own fleet": {
            // icon truck hijau
            0: truckRotate0,
            40: truckRotate40,
            90: truckRotate90,
            140: truckRotate140,
            180: truckRotate180,
            220: truckRotate220,
            270: truckRotate270,
            320: truckRotate320,
          },
          "3PL fleet": {
            // icon truck oren
            0: threePlTruckRotate0,
            40: threePlTruckRotate40,
            90: threePlTruckRotate90,
            140: threePlTruckRotate140,
            180: threePlTruckRotate180,
            220: threePlTruckRotate220,
            270: threePlTruckRotate270,
            320: threePlTruckRotate320,
          },
          "3PL Fleet": {
            // icon truck oren
            0: threePlTruckRotate0,
            40: threePlTruckRotate40,
            90: threePlTruckRotate90,
            140: threePlTruckRotate140,
            180: threePlTruckRotate180,
            220: threePlTruckRotate220,
            270: threePlTruckRotate270,
            320: threePlTruckRotate320,
          },
          "Rental Fleet": {
            // icon truck putih
            0: renteeTruckRotate0,
            40: renteeTruckRotate40,
            90: renteeTruckRotate90,
            140: renteeTruckRotate140,
            180: renteeTruckRotate180,
            220: renteeTruckRotate220,
            270: renteeTruckRotate270,
            320: renteeTruckRotate320,
          },
          "Rental fleet": {
            // icon truck putih
            0: renteeTruckRotate0,
            40: renteeTruckRotate40,
            90: renteeTruckRotate90,
            140: renteeTruckRotate140,
            180: renteeTruckRotate180,
            220: renteeTruckRotate220,
            270: renteeTruckRotate270,
            320: renteeTruckRotate320,
          },
        }),
  };

  const selectedIconSet = iconSets[owner] || iconSets["Own Fleet"];
  return getIcon(selectedIconSet);
};

export const handleFleetOwner = (owner) => {
  switch (owner) {
    case "Own Fleet":
      return process.env.IS_MITRATEL?suvWhite0:truckRotate0;
    case "Own fleet":
      return process.env.IS_MITRATEL?suvWhite0:truckRotate0;
    case "3PL Fleet":
      return process.env.IS_MITRATEL?suvOrange0:threePlTruckRotate0;
    case "3PL fleet":
      return process.env.IS_MITRATEL?suvOrange0:threePlTruckRotate0;
    case "Rental Fleet":
      return process.env.IS_MITRATEL?suvYellow0:renteeTruckRotate0;
    case "Rental fleet":
      return process.env.IS_MITRATEL?suvYellow0:renteeTruckRotate0;
    default:
      return process.env.IS_MITRATEL?suvWhite0:truckRotate0;
  }
};

export const handleMarkerType = (data) => {
  switch (data) {
    case "AABAC":
      return circleMarkerBlue;
    case "CAME":
      return circleMarkerGreen;
    case "LATAM":
      return circleMarkerBlack;
    case "FCA":
      return circleMarkerRed;

    default:
      return circleMarkerRed;
  }
};

export function formatNumber(input) {
  const number = Number(input);
  if (isNaN(number)) {
    return "0";
  }
  // Format angka ke dalam format ribuan
  return number.toLocaleString("en-EN");
}

export const saveAs = (blob, name) => {
  var url = URL.createObjectURL(blob);
  var a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
};

export const getTimezone = () => {
  const d = new Date();
  let diff = d.getTimezoneOffset() / -60;

  return diff;
};

export const distanceByGoogle = (origin, destination, index = 0) => {
  return new Promise((resolve, reject) => {
    const service = new window.google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === "OK") {
          resolve({ response, index });
        } else {
          reject(response);
        }
      }
    );
  });
};

export const isPointInPolygon = (point, polygon) => {
  const [y, x] = point;
  let isInside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [yi, xi] = polygon[i];
    const [yj, xj] = polygon[j];

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) isInside = !isInside;
  }

  return isInside;
};

export const isPointInRadius = (point, area) => {
  const earthRadius = 6371 * 1000;

  const toRadians = (degrees) => degrees * (Math.PI / 180);

  const dLat = toRadians(point.lat - area.lat);
  const dLng = toRadians(point.lng - area.lng);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(area.lat)) *
      Math.cos(toRadians(point.lat)) *
      Math.sin(dLng / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = earthRadius * c;

  return distance <= area.radius;
}

export const escapeInnerQuotes = (str) => {
  let insideString = false;
  let escaped = false;
  let result = '';

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    if (char === '"' && !escaped) {
      // toggle only if it's a real string boundary
      if (!insideString) {
        insideString = true;
      } else {
        // check if the next char means this is an inner quote (e.g. letter)
        const next = str[i + 1];
        if (next && ![':', ',', '}', ']', '\n', '\r', ' '].includes(next)) {
          result += '\\"'; // escape it
          continue;
        }
        insideString = false;
      }
    } else if (char === '\\' && !escaped) {
      escaped = true;
      result += char;
      continue;
    }

    escaped = false;
    result += char;
  }

  return result;
}


export const jsonfix = (jsonStr) => {
  function countBraces(jsonStr) {
    let open = 0;
    let close = 0;

    for (const char of jsonStr) {
      if (char === "{") open++;
      if (char === "}") close++;
    }

    return { open, close };
  }
  let str = jsonStr
    .replace(/:\s*\d+\.\s*[a-zA-Z]+/g, ': "value is invalid"') // remove invalid value
    .replace(/^"(.*)"$/, "$1") // remove /n
    .replace(/\\"/g, '"')  // remove /n
    .replace(/\n/g, "\\n") // remove /n

  var totalBraces = countBraces(str);

  if (totalBraces.open > totalBraces.close) {
    var strSplit = str.split("");

    var fixed = false;

    for (var i = 0; i < strSplit.length; i++) {
      if (!fixed && i != 0) {
        if (strSplit[i] === "," && strSplit[i - 1] === '"') {
          var newStr = [
            ...strSplit.filter((item, index) => index <= i - 1),
            "}",
            ...strSplit.filter((item, index) => index >= i),
          ].join("");
          try {
            JSON.parse(newStr);
            str = newStr;
            fixed = true;
          } catch (err) {
            fixed = false;
          }
        }
      } else {
        continue;
      }
    }
  }

  return str;
};